// src/scripts/app.js
// Tab functionality
document.querySelectorAll('.tab-button').forEach((button)=>{
    button.addEventListener('click', ()=>{
        const tabId = button.getAttribute('data-tab');
        // Remove active class from all buttons and contents
        document.querySelectorAll('.tab-button').forEach((btn)=>btn.classList.remove('active'));
        document.querySelectorAll('.tab-content').forEach((content)=>content.classList.remove('active'));
        // Add active class to the clicked button and corresponding content
        button.classList.add('active');
        const tabElement = document.getElementById(tabId);
        if (tabElement) tabElement.classList.add('active');
        // Scroll to the top of the page
        window.scrollTo({
            top: 0,
            behavior: 'smooth'
        });
    });
});
// Dynamically set contact links to help reduce bot scraping
document.addEventListener('DOMContentLoaded', function() {
    // Email
    const emailUser = 'katindia.js';
    const emailDomain = 'gmail.com';
    const emailElement = document.getElementById('emailLink');
    if (emailElement) emailElement.setAttribute('href', 'mailto:' + emailUser + '@' + emailDomain);
    // Phone
    const phoneCountryCode = '+91';
    const phoneNumber = '9828577515'; // Raw digits for the tel: link
    // const phoneDisplayNumber = '982-857-7515'; // Formatted for display - HTML now handles this
    const phoneElement = document.getElementById('phoneLink');
    if (phoneElement) phoneElement.setAttribute('href', 'tel:' + phoneCountryCode + phoneNumber);
});

//# sourceMappingURL=my-website.05406dc6.js.map
